<template>
  <div class="header">
    <img class="logo" :src="isOverseas ? logoEn : logoZh" @click="jumpToHome">
    <div class="drawer" @click="switchDrawer">
      <img :class="['drawer-icon', animateIcon && 'icon-animate']" :src="showDrawer ? closeIcon : drawerIcon">
    </div>
    <div class="tab-container" :class="{
      'is-home': activeMenu === 'home',
      'is-detail': activeMenu === 'detail',
      'is-video': activeMenu === 'video',
    }">
      <span v-show="['home', 'detail', 'video'].includes(activeMenu)" class="tab-indicator" aria-hidden="true"></span>
      <button :class="['tab-item', activeMenu === 'home' && 'active']" @click="jumpTo('index')">{{ t('home')
        }}</button>
      <button :class="['tab-item', activeMenu === 'detail' && 'active']"
        @click="jumpTo(isOverseas ? 'overseas-detail' : 'detail')">{{ t('detail')
        }}</button>
      <button :class="['tab-item', activeMenu === 'video' && 'active']" @click="jumpTo('video')">{{ t('video')
      }}</button>
      <div v-if="isOverseas" class="lang">{{ currentLang }}
        <div class="lang-container">
          <section :class="locale === value.code && 'active-lang'" v-for="value in langMap"
            @click="switchLang(value.code)">
            {{ t(`lang.${value.code}`) }}</section>
        </div>
      </div>
    </div>

  </div>
  <div class="drawer-container" v-show="showDrawer"
    :style="locale === 'zh' ? 'padding-top:7rem' : 'padding-top:4.32rem'">
    >
    <div :class="[activeMenu == 'home' && 'active']" @click="jumpTo('index')">{{ t('home') }}</div>
    <div :class="[activeMenu == 'detail' && 'active']" @click="jumpTo(isOverseas ? 'overseas-detail' : 'detail')">{{
      t('detail') }}</div>
    <div :class="[activeMenu == 'video' && 'active']" @click="jumpTo('video')">{{ t('video') }}</div>
    <div class="lang" v-if="isOverseas">
      <section :class="locale === value.code && 'active-lang'" v-for="value in langMap" @click="switchLang(value.code)">
        {{ t(`lang.${value.code}`) }}</section>
    </div>
  </div>
</template>

<script setup lang="ts">
import logoZh from '@/assets/images/header/logo.png'
import logoEn from '@/assets/images/header/logo-en.png'
import drawerIcon from '@/assets/images/header/drawer-icon.png'
import closeIcon from '@/assets/images/header/close-icon.png'
const route = useRoute()
const activeMenu = ref<string>(route.meta.pageType as string)
const router = useRouter()
const localePath = useLocalePath();
const { locale, setLocale, t } = useI18n();
//是否海外
const { isOverseas } = useAppState()
const langMap = ref([{ code: 'en', name: 'English' },
{ code: 'pt', name: 'Português' },
{ code: 'es', name: 'Español' },
{ code: 'ar', name: 'العربية' },
{ code: 'vi', name: 'Tiếng Việt' }])
const currentLang = computed(() => {
  return (langMap.value.find(item => item.code === locale.value) as { code: string; name: string }).name
})
watch(route, () => {
  activeMenu.value = route.meta.pageType as string
}, { deep: true })
//跳转
const jumpTo = (pagePath: string) => {
  console.log('pagePath', pagePath)
  showDrawer.value = false
  const localizedPath = localePath({ name: pagePath })
  router.push({ path: localizedPath })
}
//切换语言
const switchLang = async (code: any) => {
  await setLocale(code)
  setTimeout(() => {
    window.location.reload()
  }, 500)
}
const jumpToHome = () => {
  // router.push({ path: '/' })
  location.href = location.origin
}
const showDrawer = ref(false)
const animateIcon = ref(false)
const switchDrawer = () => {
  animateIcon.value = true
  setTimeout(() => {
    animateIcon.value = false
    showDrawer.value = !showDrawer.value
  }, 333)
}
</script>

<style lang="less" scoped>
.header {
  width: 1022px;
  height: 167px;
  padding: 0 14px 0 55px;
  box-sizing: border-box;
  background: transparent;
  border-radius: 438px;
  border: 1px solid #FFFFFF;
  isolation: isolate;
  position: fixed;
  top: 37px;
  left: 29px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 100;

  .tab-container {
    display: none;
  }

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(25px);
    -webkit-backdrop-filter: blur(25px);
    pointer-events: none;
    z-index: -1;
  }

  .logo {
    width: 204px;
    height: 112px;
    cursor: pointer;
  }

  .drawer {
    width: 138px;
    height: 138px;
    background-color: #D777FF;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &-icon {
      width: 63px;
      height: 55px;
    }

    .icon-animate {
      animation: scale .333s ease-out;
    }

    @keyframes scale {
      0% {
        opacity: 1;
        transform: scale(1);
      }

      50% {
        opacity: 0;
        transform: scale(0);
      }

      100% {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}

.drawer-container {
  width: 100vw;
  min-height: 100vh;
  max-height: 100vh;
  box-sizing: border-box;
  overflow-y: scroll;
  background: rgba(255, 255, 255, 0.49);
  backdrop-filter: blur(56px);
  -webkit-backdrop-filter: blur(56px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 98;
  animation: opacityAn .333s ease-out;

  @keyframes opacityAn {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  div {
    width: 395px;
    height: 115px;
    border-radius: 58px;
    font-weight: bold;
    font-size: 52px;
    line-height: 78px;
    text-align: center;
    color: #000000;
    line-height: 115px;
    margin: 0 auto;
    padding: 63px 0;
  }

  div:not(:last-child)::after {
    content: '';
    display: block;
    width: 311px;
    height: 1px;
    background: rgba(151, 151, 151, 0.48);
    margin: auto;
    transform: translate(0, 63px);
  }

  .lang {
    height: 700px;
    overflow-y: auto;

    section {
      font-weight: bold;
      font-size: 46px;
      color: rgba(0, 0, 0, 0.96);
      line-height: 69px;
      margin-top: 55px;
      position: relative;
    }
  }

  .active-lang::before {
    content: '';
    display: inline-block;
    width: 23px;
    height: 23px;
    background: #D777FF;
    border-radius: 50%;
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translate(0, -50%);
  }

  .active {
    position: relative;
    color: #FFFFFF;

    &::before {
      content: "";
      position: absolute;
      display: block;
      background-color: #D777FF;
      height: 115px;
      width: 100%;
      top: 63px;
      z-index: -1;
      border-radius: 58px;
    }
  }
}

@media only screen and (min-width: 768px) {
  .drawer-container {
    display: none !important;
  }

  .header {
    width: calc(100% - 22px);
    height: 40px;
    right: 11px;
    top: 11px;
    left: inherit;
    padding: 0;
    text-align: right;

    .logo {
      position: fixed;
      width: 57px;
      height: 32px;
      left: 30px;
      top: 15px;
    }

    .drawer {
      display: none;
    }

    .tab-container {
      display: flex;
      position: absolute;
      align-items: center;
      padding: 0 9px;
      height: 100%;
      width: auto;
      right: 0px;


      .tab-item,
      .lang {
        width: 77px;
        height: 23px;
        padding: 0;
        border: 0;
        background: transparent;
        text-align: center;
        font-weight: bold;
        font-size: 10px;
        color: #000000;
        cursor: pointer;
        position: relative;
        z-index: 1;
        transition: color 220ms ease;
      }

      .lang {
        line-height: 23px;
      }

      .tab-item.active {
        color: #FFFFFF;
      }

      .tab-indicator {
        width: 77px;
        height: 23px;
        position: absolute;
        top: 50%;
        left: 9px;
        border-radius: 12px;
        background: #d677fe;
        backdrop-filter: blur(8px) saturate(145%);
        -webkit-backdrop-filter: blur(8px) saturate(145%);
        pointer-events: none;
        transform: translateX(0) translateY(-50%) scale(1);
        transform-origin: center;
        transition: transform 520ms cubic-bezier(0.22, 1.45, 0.36, 1), border-radius 360ms ease;
        z-index: 0;
      }

      &.is-detail .tab-indicator {
        transform: translateX(77px) translateY(-50%);
      }

      &.is-video .tab-indicator {
        transform: translateX(154px) translateY(-50%);
      }

      &.is-home .tab-indicator {
        transform: translateX(0) translateY(-50%) scale(1);
      }
    }

    .lang {
      position: relative;

      &:hover {
        .lang-container {
          display: block;
        }
      }

      &::before {
        content: '';
        display: block;
        position: absolute;
        width: 100px;
        top: 20px;
        height: 20px;
        left: 50%;
        transform: translate(-50%, 0);
      }

      .lang-container {
        display: none;
        position: absolute;
        height: auto;
        left: 50%;
        top: 35px;
        width: 100px;
        transform: translate(-50%, 0);
        background-color: #ffffff;
        border-radius: 10px;
        padding: 8px 0;

        section:hover::after {
          content: '';
          display: inline-block;
          width: 6px;
          height: 6px;
          background: #D777FF;
          border-radius: 50%;
          position: absolute;
          left: 10px;
          top: 50%;
          transform: translate(0, -50%);
        }

        section {
          position: relative;
          font-weight: bold;
          font-size: 10px;
          color: #1F1F1F;
          line-height: 15px;
          padding: 5px 0;
          text-align: center;
          cursor: pointer;
        }
      }
    }

    .lang::after {
      content: '';
      background-image: url('../../assets/images/header/arrow-down.png');
      background-size: 100%;
      background-repeat: no-repeat;
      display: inline-block;
      width: 6px;
      height: 3px;
      margin-left: 2px;
      vertical-align: middle;
    }


  }
}

.vi {
  .lang {
    width: 500px;
  }

  .lang-container {
    width: 150px !important;
    right: -10px;
    left: inherit !important;
    transform: translate(0, 0) !important;
  }
}

.ar {
  .header {
    left: 11px;
    right: inherit;
    flex-direction: row-reverse;
    padding: 0 0.55rem 0 0.14rem;
  }

  .tab-container {
    right: inherit;
    left: 0;
  }

  .logo {
    right: 30px;
    left: initial;
  }

  @media only screen and (min-width: 768px) {
    .header {
      padding: 0;
    }
  }
}
</style>
